import "react-toastify/dist/ReactToastify.css";
import "./testGenAI.css";

import { ToastContainer } from "react-toastify";

import {
  Box
} from "@mui/material";

import MainChatPage from "./MainChatPage";
import ChatInput from "./ChatInput";
import TopBar from "./TopBar";

const AIChatHomePage = ({
  displayName,
  question,
  setQuestion,
  onRequest,
  getCaptionsAnswer,
  onEnterPress,
  onViewHistory,
  chatWrapperRef,
  mainPageCaptions,
  botIconImg
}) => {

  return (
    <div className="analytics">
      <TopBar
        displayName={displayName}
        showNewChat={false}
        showHistoryButton={onViewHistory ?true: false}
        onNewChat={() => {}}
        onViewHistory={onViewHistory}
      />

      <div className="card cardAdditionalStyling">
        <ToastContainer />
        <div
          ref={chatWrapperRef}
          className="card subcard box-container"
          id="mainScrollableDiv"
        >
          <Box className="messageBox">
            <Box className="boxStyling">
              <MainChatPage mainPageCaptions={mainPageCaptions} botIconImg={botIconImg}/>
            </Box>
          </Box>
        </div>
        <ChatInput
          question={question}
          setQuestion={setQuestion}
          onRequest={onRequest}
          getCaptionsAnswer={getCaptionsAnswer}
          onEnterPress={onEnterPress}
          //onSendFirstQuestion={onSendFirstQuestion}
        />
      </div>
    </div>
  );
};

export default AIChatHomePage;
